/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { DriverDtoModel, DriverDtoModelType } from "./DriverDtoModel"
import { DriverDtoModelSelector } from "./DriverDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  driver: DriverDtoModelType;
}

/**
 * DriverEditedDtoBase
 * auto generated base class for the model DriverEditedDtoModel.
 */
export const DriverEditedDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('DriverEditedDto')
  .props({
    __typename: types.optional(types.literal("DriverEditedDto"), "DriverEditedDto"),
    /** Driver that was just patched */
    driver: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => DriverDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class DriverEditedDtoModelSelector extends QueryBuilder {
  driver(builder: string | DriverDtoModelSelector | ((selector: DriverDtoModelSelector) => DriverDtoModelSelector) | undefined) { return this.__child(`driver`, DriverDtoModelSelector, builder) }
}
export function selectFromDriverEditedDto() {
  return new DriverEditedDtoModelSelector()
}

export const driverEditedDtoModelPrimitives = selectFromDriverEditedDto()
